import BatteryIcon from "assets/svgIcons/BatteryIcon";
import UnKnowIcon from "assets/svgIcons/MapLegendPopup/BatteryStatus/UnKnownIcon";
import BatteryWithPowerIcon from "assets/svgIcons/BatteryWithPowerIcon";
import OnChargeIcon from "assets/svgIcons/MapLegendPopup/BatteryStatus/OnCharge";

function RenderBatteryIcon({ car }) {
  const redLevel = car.BatteryLevel <= 10;
  const yellowLevel = car.BatteryLevel > 10 && car.BatteryLevel < 26;
  const greenLevel = car.BatteryLevel > 25 && car.BatteryLevel <= 100;
  const unknownLevel = car.BatteryLevel > 100;

  if (car.IsCharging) {
    if (car.BatteryLevel >= 95) return <BatteryWithPowerIcon />;
    else return <OnChargeIcon width={37} height={22} />;
  } else {
    if (redLevel) {
      return <BatteryIcon color="#FA3C30" />;
    } else if (greenLevel) {
      return <BatteryIcon color="#00A692" />;
    } else if (yellowLevel) {
      return <BatteryIcon color="#FFD707" />;
    } else if (unknownLevel) {
      // return <BatteryIcon width={18.5} height={10} color="#FFF" />;
      return <UnKnowIcon width={40} height={24} />;
    } else {
      return <span>no Icon available</span>;
    }
  }
}

export default RenderBatteryIcon;
